import React, { memo } from 'react';
import type { FunctionComponent, ReactNode } from 'react';
import './DataBlock.scss';

export interface DataBlockRowInterface {
	title: string;
	children?: ReactNode;
}

export const DataBlockRow: FunctionComponent<DataBlockRowInterface> = memo(({ title, children }) => (
	<div className="data-block__row">
		<div className="data-block__item">{title}</div>
		<div className="data-block__value">{children}</div>
	</div>
));
